import $ from 'jquery'

$('.feed-part-cert > img').on('click', function () {
  $(this).parent().find('.feed-part-cert__content').addClass('active')
  $('body').css('overflow', 'hidden')
})

$('.feed-part-cert__closer').on('click', function () {
  $(this).closest('.feed-part-cert__content').removeClass('active')
  $('body').css('overflow', '')
})

$('.feed-part-cert__content').on('click', function (e) {
  if (e.target !== this) return
  $(this).closest('.feed-part-cert__content').removeClass('active')
  $('body').css('overflow', '')
})
